export const FACEBOOK_API_VERSION = 'v26.0'
